const STORES_TABLE_READY = "stores-table-ready"

const ADD_EDIT_STORE_READY = "add-edit-store-ready"


const STORES_TICKETS_TABLE_READY = "stores-tickets-table-ready"
const STORES_TICKETS_LIVE_TABLE_READY = "stores-tickets-Live-table-ready"
const STORE_TICKETS_AGENTS_TABLE_READY = "store-tickets-agents-table-ready"



const SEARCH_TEXT_STATE = "stores-table-search-text-state"
const SEARCH_STORE_TICKET_TEXT_STATE=  "stores-table-store-ticket-search-text-state"

const SEARCH_ST_AGENT_TABLE_TEXT_STATE = "stores-agents-table-search-text-state"

const ROWS_PER_PAGE_STATE = "stores-table-rows-per-page-state"
const PAGINATION_STATE = "stores-table-pagination-state"


const ROWS_TICKETS_PER_PAGE_STATE = "stores-tickets-table-rows-per-page-state"
const PAGINATION_TICKETS_STATE = "stores-tickets-table-pagination-state"

const ROWS_AGENTS_PER_PAGE_STATE = "stores-agents-table-rows-per-page-state"
const PAGINATION_AGENTS_STATE = "stores-agents-table-pagination-state"

const STORE_ID_FOR_ACTION = "stores-table-store-id-for-action"
const STORE_TICKET_ID_FOR_ACTION = "stores-ticket-store-id-for-action"
const ST_AGENT_ROW_FOR_ACTION = "st-agent-row-for-action"

const ADD_EDIT_STORE_KITCHEN_DATA_ACTION = "add-edit-store-kitchen-data-for-action"
const ADD_EDIT_STORE_ID_FOR_ACTION = "add-edit-store-id-for-action"





const STORES_ADD_EDIT_TIMING_READY = "stores-add-edit-timing-ready"
const STORES_TICKETS_UPDATE_READY = "stores-tickets-update-ready"
const ADD_ST_AGENT_KTICHENS_READY = "add-st-agent-kitchens-ready"


const ASSIGN_AGENTS_STORES_TICKETS_UPDATE_READY = "assign-agent-stores-tickets-update-ready"

const PREVIOUS_STORE_FILTER_START_DATE = "stores-tickets-previous-start-date"
const PREVIOUS_STORE_FILTER_END_DATE = "stores-tickets-previous-end-date"
const PREVIOUS_STORE_FILTER_CITY = "stores-tickets-previous-city"
const PREVIOUS_STORE_FILTER_KITCHEN = "stores-tickets-previous-kitchen"
const PREVIOUS_STORE_FILTER_STORE = "stores-tickets-previous-store"
const PREVIOUS_STORE_FILTER_STATUS = "stores-tickets-previous-status"
const PREVIOUS_STORE_FILTER_PLATFORM = "stores-tickets-previous-platform"

const PREVIOUS_ST_AGENT_STORE_FILTER_KITCHEN = "stores-st_agent-tickets-previous-kitchen"




const initialState = {
    isStoresTableReady: true,
    isStoresTicketsTableReady: true,
    isStoresTicketsLiveTableReady: true,
    isStoreAddEditTimingReady:true,
    isStoreTicketUpdateReady:true,
    isStoreTicketsAgentsTableReady:true,
    isAddSTAgentKitchensReady:true,
    isAssignAgentStoreTicketUpdateReady:true,
    isAddEditStoreReady:true,

    stores: {},



    previousFilterStartDate: "",
    previousFilterEndDate: "",
    previousFilterCity: "",
    previousFilterStatus: "",
    previousFilterKitchen: "",
    previousFilterStore: "",
    previousFilterPlatform: "",

    previousSTAgentFilterKitchen:"",
    
    storeSelectedId: null,

    addEditStoreSelectedId:null,
    addEditStoreKitchenData:{},

    storesTicketSelectedId: null,

    stAgentSelectedRow:null,

    
    previousSearchText: "",
    previousSTAgentTableSearchText:"",
    previousStoreTicketSearchText:"",
    previousRowsPerPageValue: 15,
    previousPaginationValue: 1,
    
    previousTicketsRowsPerPageValue: 15,
    previousTicketsPaginationValue: 1,
    
    previousAgentsRowsPerPageValue: 15,
    previousAgentsPaginationValue: 1,
    
}


export default function reducer(state = initialState, action) {
    let duplicateState = null
    switch (action.type) {
        case STORES_TABLE_READY:
            return Object.assign({}, state, { isStoresTableReady: action.payload })
        case ADD_EDIT_STORE_READY:
            return Object.assign({}, state, { isAddEditStoreReady: action.payload })
        case STORES_TICKETS_TABLE_READY:
            return Object.assign({}, state, { isStoresTicketsTableReady: action.payload })
        case STORES_TICKETS_UPDATE_READY:
            return Object.assign({}, state, { isStoreTicketUpdateReady: action.payload })
        case ASSIGN_AGENTS_STORES_TICKETS_UPDATE_READY:
            return Object.assign({}, state, { isAssignAgentStoreTicketUpdateReady: action.payload })
        case STORES_TICKETS_LIVE_TABLE_READY:
            return Object.assign({}, state, { isStoresTicketsLiveTableReady: action.payload })
        case STORE_TICKETS_AGENTS_TABLE_READY:
            return Object.assign({}, state, { isStoreTicketsAgentsTableReady: action.payload })
        case ADD_ST_AGENT_KTICHENS_READY:
            return Object.assign({}, state, { isAddSTAgentKitchensReady: action.payload })


        case STORES_ADD_EDIT_TIMING_READY:
            return Object.assign({}, state, { isStoreAddEditTimingReady: action.payload })
        
        case SEARCH_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSearchText = action.payload
            return Object.assign({}, state, duplicateState)

        case SEARCH_STORE_TICKET_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousStoreTicketSearchText = action.payload
            return Object.assign({}, state, duplicateState)


        case SEARCH_ST_AGENT_TABLE_TEXT_STATE :
            duplicateState = Object.assign({}, state)
            duplicateState.previousSTAgentTableSearchText = action.payload
            return Object.assign({}, state, duplicateState)

        
        case ROWS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)


        
        case ROWS_TICKETS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousTicketsRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_TICKETS_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousTicketsPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        
        case ROWS_AGENTS_PER_PAGE_STATE:
            duplicateState=Object.assign({},state)
            duplicateState.previousAgentsRowsPerPageValue= action.payload
            return Object.assign({}, state, duplicateState)
        
        case PAGINATION_AGENTS_STATE:
            duplicateState= Object.assign({},state)
            duplicateState.previousAgentsPaginationValue = action.payload
            return Object.assign({}, state, duplicateState)

        case STORE_ID_FOR_ACTION:
            return Object.assign({}, state, {storeSelectedId:action.payload})

        case ADD_EDIT_STORE_ID_FOR_ACTION:
            return Object.assign({}, state, {addEditStoreSelectedId:action.payload})

        case ADD_EDIT_STORE_KITCHEN_DATA_ACTION:
            return Object.assign({}, state, {addEditStoreKitchenData:action.payload})

        case STORE_TICKET_ID_FOR_ACTION:
            return Object.assign({}, state, {storesTicketSelectedId:action.payload})
        case ST_AGENT_ROW_FOR_ACTION:
            return Object.assign({}, state, {stAgentSelectedRow:action.payload})




        case PREVIOUS_STORE_FILTER_START_DATE:
            return Object.assign({}, state, {previousFilterStartDate:action.payload})
        case PREVIOUS_STORE_FILTER_END_DATE:
            return Object.assign({}, state, {previousFilterEndDate:action.payload})
        case PREVIOUS_STORE_FILTER_CITY:
            return Object.assign({}, state, {previousFilterCity:action.payload})
        case PREVIOUS_STORE_FILTER_STATUS:
            return Object.assign({}, state, {previousFilterStatus:action.payload})
        case PREVIOUS_STORE_FILTER_KITCHEN:
            return Object.assign({}, state, {previousFilterKitchen:action.payload})
            
        case PREVIOUS_STORE_FILTER_STORE:
            return Object.assign({}, state, {previousFilterStore:action.payload})
        case PREVIOUS_STORE_FILTER_PLATFORM:
            return Object.assign({}, state, {previousFilterPlatform:action.payload})

        case PREVIOUS_ST_AGENT_STORE_FILTER_KITCHEN:
            return Object.assign({}, state, {previousSTAgentFilterKitchen:action.payload})






        default:
        return state
    
    }

}


export function storesTableReady(data) {
    return {
        type: STORES_TABLE_READY,
        payload: data
    }
}

export function addEditStoreReady(data) {
    return {
        type: ADD_EDIT_STORE_READY,
        payload: data
    }
}



export function storesTicketsTableReady(data) {
    return {
        type: STORES_TICKETS_TABLE_READY,
        payload: data
    }
}

export function assigneAgentStoreTicketsUpdateReady(data) {
    return {
        type: ASSIGN_AGENTS_STORES_TICKETS_UPDATE_READY,
        payload: data
    }
}





export function sTAgentsTableReady(data) {
    return {
        type: STORE_TICKETS_AGENTS_TABLE_READY,
        payload: data
    }
}



export function storesTicketsLiveTableReady(data) {
    return {
        type: STORES_TICKETS_LIVE_TABLE_READY,
        payload: data
    }
}



export function storeAddEditTimingReady(data) {
    return {
        type: STORES_ADD_EDIT_TIMING_READY,
        payload: data
    }
}

export function addSTAgentKitchensReady(data) {
    return {
        type: ADD_ST_AGENT_KTICHENS_READY,
        payload: data
    }
}


export function storeTicketsUpdateReady(data) {
    return {
        type: STORES_TICKETS_UPDATE_READY,
        payload: data
    }
}


export function searchTextState(searchText){
    return {
        type:SEARCH_TEXT_STATE,
        payload:searchText
    }
}

export function searchSTAgentTableTextState(searchText){
    return {
        type:SEARCH_ST_AGENT_TABLE_TEXT_STATE,
        payload:searchText
    }
}






export function searchStoreTicketTextState(searchText){
    return {
        type:SEARCH_STORE_TICKET_TEXT_STATE,
        payload:searchText
    }
}

export function rowsPerPageState(rows){
    return {
        type:ROWS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationState(pageNo){
    return{
        type:PAGINATION_STATE,
        payload:pageNo
    }
}



export function rowsTicketsPerPageState(rows){
    return {
        type:ROWS_TICKETS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationTicketsState(pageNo){
    return{
        type:PAGINATION_TICKETS_STATE,
        payload:pageNo
    }
}

export function rowsAgentsPerPageState(rows){
    return {
        type:ROWS_AGENTS_PER_PAGE_STATE,
        payload:rows
    }
}

export function paginationAgentsState(pageNo){
    return{
        type:PAGINATION_AGENTS_STATE,
        payload:pageNo
    }
}

export function storesIdForAction(storesId){
    return{
        type:STORE_ID_FOR_ACTION,
        payload:storesId
    }
}

export function addEditStoreIdForAction(storesId){
    return{
        type:ADD_EDIT_STORE_ID_FOR_ACTION,
        payload:storesId
    }
}

export function addEditStoreKitchenDataForAction(data){
    return{
        type:ADD_EDIT_STORE_KITCHEN_DATA_ACTION,
        payload:data
    }
}

export function storesTicketIdForAction(storesTicketSelectedId){
    return{
        type:STORE_TICKET_ID_FOR_ACTION,
        payload:storesTicketSelectedId
    }
}

export function sTAgentsRowForAction(row){
    return{
        type:ST_AGENT_ROW_FOR_ACTION,
        payload:row
    }
}



export function previousFilterStartDate(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_START_DATE,
        payload:fiter_val
    }
}


export function previousFilterEndDate(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_END_DATE,
        payload:fiter_val
    }
}



export function previousFilterCity(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_CITY,
        payload:fiter_val
    }
}


export function previousFilterStatus(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_STATUS,
        payload:fiter_val
    }
}


export function previousFilterKitchen(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_KITCHEN,
        payload:fiter_val
    }
}

export function previousSTAgentFilterKitchen(fiter_val){
    return{
        type:PREVIOUS_ST_AGENT_STORE_FILTER_KITCHEN,
        payload:fiter_val
    }
}





export function previousFilterStore(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_STORE,
        payload:fiter_val
    }
}

export function previousFilterPlatform(fiter_val){
    return{
        type:PREVIOUS_STORE_FILTER_PLATFORM,
        payload:fiter_val
    }
}








// WEBPACK FOOTER //
// ./src/modules/Stores/redux/stores.js